import { useEffect, useState } from "react";

const NAV_LINKS = [
  { label: "今日热榜", href: "#hot" },
  { label: "热帖精选", href: "#featured" },
  { label: "论坛爆料", href: "#leak" },
  { label: "神贴仓库", href: "#god" },
  { label: "栏目导览", href: "#topics" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <header
        className={`sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur transition-shadow ${
          scrolled ? "border-background-300" : ""
        }`}
      >
        <div className="mx-auto flex max-w-7xl items-center gap-4 px-4 py-3 md:px-6">
          <a href="#top" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-window-2-line text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="masthead-wordmark text-xl font-black text-foreground-950">海角网</span>
              <span className="mt-1 hidden text-[10px] tracking-[0.22em] text-foreground-500 md:block">
                天涯热帖 · 论坛爆料 · 神贴精选
              </span>
            </span>
          </a>

          <nav className="ml-auto hidden items-center gap-1 lg:flex">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-2 lg:ml-2">
            <button
              type="button"
              aria-label="搜索"
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-foreground-700 transition-colors hover:bg-secondary-100"
            >
              <i className="ri-search-line text-lg" />
            </button>
            <a
              href="#hot"
              className="hidden cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
            >
              开刷热榜
            </a>
            <button
              type="button"
              aria-label="菜单"
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-foreground-950 transition-colors hover:bg-secondary-100 lg:hidden"
            >
              <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} />
            </button>
          </div>
        </div>

        {open ? (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
            <nav className="flex flex-col gap-1">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="cursor-pointer rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-secondary-100"
                >
                  {l.label}
                </a>
              ))}
            </nav>
          </div>
        ) : null}
      </header>
    </>
  );
}